import { FunctionComponent } from 'react';
import { HasChildren } from 'src/common/props';

export interface HeroHeaderProps extends HasChildren {}

export const HeroHeader: FunctionComponent<HeroHeaderProps> = ({ children }) => {
    return <header>{children}</header>;
};
